import { Abi } from "viem"

export function isValidAbi(abi: unknown): abi is readonly unknown[] | Abi {
  return Array.isArray(abi) || "length" in (abi as Abi)
}
